import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EmailConfirmComponent } from '@dhi/candidate-tool/data-layer';
import { ForgotPasswordComponent } from '@dhi/candidate-tool/data-layer';

const routes: Routes = [
    {
        path: 'email-validation',
        component: EmailConfirmComponent

    },
    {
        path: '',
        component: ForgotPasswordComponent
    }

];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})

export class AppRoutingModule {}
